import React from 'react';

import { InfoIcon, Stack, Typography } from '@gogame/components';

const Importance = ({ id, children, fontSize, tooltip, ...props }) => {
  const content = (
    <Typography {...props} noWrap as={'span'}>
      {children}
    </Typography>
  );
  switch (id) {
    case 0:
      return content;
    case 1:
      return (
        <Stack
          spacing={1}
          direction={'row'}
          alignItems={'center'}
          as={'span'}
          xs={{ minWidth: 0 }}
        >
          {content}
          <InfoIcon sx={{ color: '#EC7D05', fontSize: 16 }} />
        </Stack>
      );
  }
};

export default Importance;
